// removed by extract-text-webpack-plugin
module.exports = {"lecture-page":"_3NtEMxvVHYKRQshvWGAUa-","explore-bg":"_2IwZiCdY32gFu6v_Yq5hW0","bg-quote":"_3qz10Xf_WmAF3tRmnJibvb","explore-quote":"_3LsnsXDJG1J_1K4q87i7U_","explore-bar":"_2j1iDRuMuZvF0TBrimxY9b","page-title-container--v1":"_2JeS1bfK9hfaKruqiytSA7","my-lecture":"_3IRn7J_3Y8xfv-byLvyzwa","lecture-item":"_14q0LC1GTGTSzgLeo9zT7e","page-title":"_3a0W6GLldOJvI7A51DPoKq","create-btn":"_1SPyeXnjF2Nigm95Y6gPXg"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/MyLecturePage/my-lecture-page.scss
// module id = 1752
// module chunks = 0